(() => {
  const COOKIE_NAME = "mana_referral_attribution";
  const CART_ATTRIBUTE = "_mana_referral_attribution";
  const APP_PROXY_ENDPOINT = "/apps/super-mana/referrals/attribution";

  function readCookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const item = document.cookie.split("; ").find((part) => part.startsWith(prefix));
    return item ? decodeURIComponent(item.slice(prefix.length)) : "";
  }

  function writeCookie(name, value, maxAge) {
    document.cookie = [
      `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
      "Path=/",
      `Max-Age=${Math.max(60, Number(maxAge) || 2592000)}`,
      "SameSite=Lax",
      "Secure",
    ].join("; ");
  }

  async function saveCartAttribution(token) {
    if (!token) return;

    await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({attributes: {[CART_ATTRIBUTE]: token}}),
    });
  }

  async function captureReferral() {
    const url = new URL(window.location.href);
    const referralIdentifier = String(url.searchParams.get("ref") || "").trim();

    if (!referralIdentifier) {
      await saveCartAttribution(readCookie(COOKIE_NAME));
      return;
    }

    const response = await fetch(
      `${APP_PROXY_ENDPOINT}?ref=${encodeURIComponent(referralIdentifier)}`,
      {credentials: "same-origin", headers: {Accept: "application/json"}}
    );
    if (!response.ok) return;

    const payload = await response.json();
    if (!payload?.token) return;

    writeCookie(COOKIE_NAME, payload.token, payload.max_age);
    await saveCartAttribution(payload.token);
  }

  captureReferral().catch(() => {
    // Referral attribution is helpful but must never interfere with storefront
    // navigation, the cart, or checkout when the network is unavailable.
  });
})();
 
